import script from "./SupAppsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SupAppsPage.vue?vue&type=script&setup=true&lang=js"

import "./SupAppsPage.vue?vue&type=style&index=0&id=6def9020&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6def9020"]])

export default __exports__